import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "projects/shared/environments/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})

export class TargetAlertsService {


  constructor(
    private _http: HttpClient
  ) { }

  getTargetAlerts(params: string): Observable<IAlert[]> {
    return this._http.get<IAlert[]>(`${environment.apiUrl}targeted-alerts/user?${params}`)
  }

  markAlertViewed(id: string): Observable<any> {
    return this._http.post(`${environment.apiUrl}targeted-alerts/${id}/view`, {})
  }

}

interface IAlert {
  _id: string
  title: Title
  body: Body
  targetCountries: any[]
  isGlobal: boolean
  targetUserId: any
  expiresAt: string
  priority: number
  repeatInterval: number
  isActive: boolean
  createdAt: string
  updatedAt: string
  __v: number
}

export interface Title {
  ar: string
  en: string
}

export interface Body {
  ar: string
  en: string
}
